class Top {
  constructor() {
    const reasonSwiperEl = document.querySelector('.js-reason-swiper');
    if(reasonSwiperEl){
      this.reasonSwiper(reasonSwiperEl);
    }
    const caseSwiperEl = document.querySelector('.js-case-swiper');
    if(caseSwiperEl) {
      this.caseSwiper(caseSwiperEl);
    }
  }
  reasonSwiper(reasonSwiperEl) {
    const progressbar = document.querySelector('.js-reason-swiper__progressbar');
    new Swiper(reasonSwiperEl,{
      slidesPerView: 'auto',
      spaceBetween: 14,
      pagination: {
        el: progressbar,
        type: 'progressbar'
      }
    })
  }
  caseSwiper(caseSwiperEl) {
    const progressbar = document.querySelector('.js-case-swiper__progressbar');
    new Swiper(caseSwiperEl,{
      slidesPerView: 'auto',
      spaceBetween: 14,
      pagination: {
        el: progressbar,
        type: 'progressbar'
      }
    })
  }
}